import { CART_ADD_ITEM,CART_REMOVE_ITEM, CART_RESET_SHIPPING_ADDRESS, CART_SAVE_PAYMENT_METHOD, CART_SAVE_SHIPPING_ADDRESS,CART_RESET_CART } from '../constants/cartConst';

export const cartReducer = (state = { cartItems: [],shippingAddress:{} }, action) => {
  switch (action.type) {
    case CART_ADD_ITEM:
      const item = action.payload;
      const existItem = state.cartItems.find((x) => x.product === item.product);
      if (existItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((x) =>
            x.product === existItem.product ? item : x
          ),
        };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }
      case CART_REMOVE_ITEM:
          return{
              ...state,cartItems:state.cartItems.filter(x=>x.product!==action.payload)
          }
          case CART_SAVE_SHIPPING_ADDRESS:
            return{
              ...state,shippingAddress:action.payload
          }
          case CART_SAVE_PAYMENT_METHOD:
            return{
              ...state,payment:action.payload
          }
          case CART_RESET_SHIPPING_ADDRESS:
            return{cartItems:[...state.cartItems], shippingAddress:{}}
          case CART_RESET_CART:
            return{cartItems:[],shippingAddress:{}}
    default:
      return state;
  }
};
